import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { INFO_MODAL } from "../data/content";
import { AURACONECT_URL } from "../lib/config";

export const InfoModal = ({ role, open, onOpenChange }) => {
  const content = role ? INFO_MODAL[role] : null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid={role ? `info-modal-${role.toLowerCase()}` : "info-modal"}
        className="max-w-md border-gold-border bg-cream"
      >
        {content && (
          <>
            <DialogHeader>
              <DialogTitle className="font-serif text-3xl text-ink">
                {content.title}
              </DialogTitle>
              <DialogDescription className="pt-2 text-sm leading-relaxed text-mutedink">
                {content.text}
              </DialogDescription>
            </DialogHeader>
            <Button
              data-testid="info-modal-close-btn"
              onClick={() => onOpenChange(false)}
              className="mt-6 w-full rounded-full bg-teal py-5 text-xs font-semibold uppercase tracking-[0.2em] text-white hover:bg-teal-hover"
            >
              Entendi
            </Button>
            <a
              data-testid="info-modal-app-link"
              href={AURACONECT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 block text-center text-[10px] font-semibold uppercase tracking-[0.2em] text-mutedink transition-colors duration-300 hover:text-teal"
            >
              Já recebeu um convite? Acesse o aplicativo
            </a>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
